import React from 'react';
import { Search } from 'lucide-react';

// Search box pinned to the top of a country-code dropdown. Enter picks the
// first match, Esc closes. `dark` suits the referral page's dark dropdown.
const CountrySearch: React.FC<{
    value: string;
    onChange: (value: string) => void;
    onPickFirst: () => void;
    onClose: () => void;
    dark?: boolean;
}> = ({ value, onChange, onPickFirst, onClose, dark = false }) => (
    <div className={`sticky top-0 z-10 pt-1.5 pb-1.5 ${dark ? 'bg-slate-900' : 'bg-white'}`}>
        <div className="relative">
            <Search size={13} className={`absolute left-2.5 top-1/2 -translate-y-1/2 pointer-events-none ${dark ? 'text-white/40' : 'text-gray-400'}`} />
            <input
                type="text"
                autoFocus
                value={value}
                onChange={e => onChange(e.target.value)}
                onKeyDown={e => {
                    if (e.key === 'Escape') onClose();
                    if (e.key === 'Enter') { e.preventDefault(); onPickFirst(); }
                }}
                placeholder="Search country or code"
                className={`w-full h-8 pl-8 pr-2.5 rounded-lg border text-xs outline-none ${dark
                    ? 'bg-white/5 border-white/15 text-white placeholder:text-white/40 focus:border-white/40'
                    : 'bg-white border-gray-200 text-gray-800 placeholder:text-gray-400 focus:border-[#1B4332]'}`}
            />
        </div>
    </div>
);

export default CountrySearch;
